import { render, staticRenderFns } from "./Pos_add_promotion_new.vue?vue&type=template&id=6567cc92&scoped=true&"
import script from "./Pos_add_promotion_new.vue?vue&type=script&lang=js&"
export * from "./Pos_add_promotion_new.vue?vue&type=script&lang=js&"
import style0 from "./Pos_add_promotion_new.vue?vue&type=style&index=0&id=6567cc92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6567cc92",
  null
  
)

export default component.exports